/**
 * 有限状态机
 */
import FSMState from '@src/slide/infrastructure/module/independent/state-machine/fsm-state';
import { IFSMMachine, IFSMState, IFSMTransition } from '@src/slide/infrastructure/module/independent/state-machine/state-machine.interface';

export default class FSMMachine extends FSMState implements IFSMMachine {
    public currentState: IFSMState | null = null;

    private privateDefaultState: IFSMState | null = null;

    private states: Array<IFSMState> = [];

    public constructor(name: string, defaultState: IFSMState | null = null) {
        super(name);
        this.defaultState = defaultState;
    }

    public addState(state: IFSMState): void {
        const tempState = state;
        if (this.states.includes(state)) return;
        this.states.push(state);
        tempState.fsmMachine = this;
        if (!this.defaultState) {
            this.defaultState = state;
        }
        if (!this.currentState) {
            this.currentState = state;
        }
    }

    public getState(name: string): IFSMState | undefined {
        return this.states.find(state => state.name === name);
    }

    public removeState(state: IFSMState): void {
        const tempState = state;
        if (this.currentState === state) return;
        if (!this.states.includes(state)) return;
        const index = this.states.indexOf(state);
        if (index >= 0) {
            this.states.splice(index, 1);
        }
        tempState.fsmMachine = null;
        if (this.defaultState === state) {
            this.defaultState = this.states.length >= 1 ? this.states[0] : null;
        }
    }

    public executeByEvent(event: string): void {
        const transitions = this.currentState ? this.currentState.transitions : [];
        const transition = transitions.find(transition => transition.event === event);
        if (transition) {
            this.doTransition(transition);
        } else {
            // 当前的状态不能做这个状态转移
            // throw new Error(`current state:${this.currentState?.name} cannot do transition by event: ${event}`);
            window.log?.warn(`current state:${this.currentState?.name} cannot do transition by event: ${event}`);
        }
    }

    public get defaultState(): IFSMState | null {
        return this.privateDefaultState;
    }

    public set defaultState(value: IFSMState | null) {
        if (value) {
            this.addState(value);
        }
        this.privateDefaultState = value;
    }

    /**
     * 开始进行过渡
     * @param transition
     */
    private doTransition(transition: IFSMTransition) {
        this.currentState?.exitCallback(transition.to);
        transition.transitionCallback();
        this.currentState = transition.to;
        this.currentState.enterCallback(transition.from);
    }
}
